/* RESPONSIBLE TEAM: team-actions */
export default function canViewIntegration(integration, app) {
  return integration.get('publiclyAvailable') || app.canUseFeature(integration.get('feature'));
}
